import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import axios from "axios";
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import { LoadPanel } from 'devextreme-react/load-panel';
import notify from 'devextreme/ui/notify';

import { alert, confirm } from 'devextreme/ui/dialog';
import Toolbar, { Item } from "devextreme-react/toolbar";
import { custom } from 'devextreme/ui/dialog';
import ValidationSummary from 'devextreme-react/validation-summary';
import PrimaryTab from "./tabs/PrimaryTab";
import VectorStoreFilesTab from "./tabs/VectorStoreFilesTab";
var skipDataLoading = false;

function Form(props) {
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const initialFormFields = {
        Id: '',
        Name: '',
        Description: '',
        Status: '',
        ExpiresAfterDays: null,
        CreatedAt: null,
        FilesInProgress: null,
        FilesCompleted: null,
        FilesCancelled: null,
        FilesFailed: null,
        FilesTotal: null,
        UsageBytes: null,
        ExpiresAt: null
    };


    const history = useHistory();
    var accessToken = props.oidc.user.access_token;
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [formFields, setformFields] = useState(initialFormFields);
    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, [setLoadPanelVisible]);
    const position = { of: '#accordion-containe2' };
    const formRefs = useRef({});

    const handleFormSubmit = async (e) => {
        setLoadPanelVisible(true);
        setIsFormSubmitted(true);
        try {
            e.preventDefault();
            if (formFields.Id == "") {
                await insertVerctorStore();
            }
            else {
                await updateVectorStore();
            }

        } catch (error) {
            console.error('Error submitting form:', error);
            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };

    const insertVerctorStore = async () => {
        try {
            const url = "ai/vectorStore/InsertVectorStore";
            let fields = formFields;

            const response = await axios.post(`${window._env_.REACT_APP_APIS}/${url}`, fields, {
                headers: {
                    'Content-Type': 'application/json',
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
            });
            if (response.status===200)
            {
                setformFields(prevFields => ({
                    ...prevFields,
                    Id: response.data.id,
                    CreatedAt: response.data.createdAt,
                    FilesInProgress: response.data.fileCounts?.inProgress,
                    FilesCompleted: response.data.fileCounts.completed,
                    FilesCancelled: response.data.fileCounts.cancelled,
                    FilesFailed: response.data.fileCounts.failed,
                    FilesTotal: response.data.fileCounts.total,
                    UsageBytes: response.data.usageBytes,
                    ExpiresAt: response.data.expiresAt,
                    Status: response.data.status,
                    ExpiresAfterDays: response.data.expiresAfter?.days
                }));
                notify(
                    {
                        message: "Vector Store Created",
                        width: 100,
                    },
                    'success',
                    3000,
                );
                setIsFormSubmitted(false);
                if (formRefs.current['Description'] && formRefs.current['Description'].instance()) 
                {
                    formRefs.current['Description'].instance().option('disabled', true);
                }
            }
            else 
            {
                notify(
                    {
                        message: "Could not create Vector Store. An error occurred",
                        width: 100,
                    },
                    'error',
                    3000,
                );
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            if (error.response.data.ERRORS && error.response.data.ERRORS.length > 0) {
                const errorHtml = error.response.data.ERRORS.map(err => `<div>${err}</div>`).join('');
                custom({
                    title: "Errors",
                    messageHtml: errorHtml,
                    buttons: [{ text: "OK", onClick: () => { } }]
                }).show();
            }
            else 
            {
                notify(
                    {
                        message: "Could not create Vector Store. An error occurred",
                        width: 100,
                    },
                    'error',
                    3000,
                );
            }

            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };
    const updateVectorStore = async () => {
        try 
        {
            const url = "ai/vectorStore/UpdateVectorStore";
            let fields = formFields;

            const response = await axios.put(`${window._env_.REACT_APP_APIS}/${url}`, fields, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
            });
            if (response.status===200)
            {
                notify(
                    {
                        message: "Vector Store Updated",
                        width: 100,
                    },
                    'success',
                    3000,
                );
                setIsFormSubmitted(false);
            }


        } 
        catch (error) 
        {
            console.error('Error submitting form:', error);

            notify
            (
                {
                    message: "Could not upate Vector Store. An error occurred",
                    width: 100,
                },
                'error',
                3000,
            );

            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };



    const primaryFormLookupsLoad = () => {
        primaryFormLoad();
    }

    const primaryFormLoad = () => {
        var id = props.id;
        if (id != null && id != undefined && id != '') {
            if (formRefs.current['Description'] && formRefs.current['Description'].instance()) 
            {
                formRefs.current['Description'].instance().option('disabled', true);
            }
        }
        else if(formFields.Id != null && formFields.Id != undefined && formFields.Id != '') 
        {
            if (formRefs.current['Description'] && formRefs.current['Description'].instance()) 
            {
                formRefs.current['Description'].instance().option('disabled', true);
            }
        }

    }

    
    const handleReset = () => {
        var id = props.id;
        if (id != null && id != undefined && id != '') {
            GetHeaderInfoById(id);
        }
        else if(formFields.Id != null && formFields.Id != undefined && formFields.Id != '') 
        {
            GetHeaderInfoById(formFields.Id);
        }
        else 
        {
            skipDataLoading = true;
            setformFields(initialFormFields);
            skipDataLoading = false;
        }

    };

    const DeleteClick = async () => {
        let result = confirm("<i>Are your sure you want to delete this record?</i>", "Delete");
        result.then(async (dialogResult) => {
            if (dialogResult) {
                setLoadPanelVisible(true);
                try {
                    const response = await axios.post(`${window._env_.REACT_APP_APIS}/${'ai/vectorstore/DeleteVectorStore'}`, formFields.Id, {
                        headers: {
                            'Content-Type': 'application/json',
                            access_token: accessToken,
                            Authorization: `Bearer ${accessToken}`
                        },
                    });
                    
                    if (response.data.deleted) 
                    {
                        notify(
                            {
                                message: "Vector Store Deleted",
                                width: 100,
                            },
                            'success',
                            3000,
                        );
                        setLoadPanelVisible(false);
                        history.push('/ai/vectorstore-data-entry');
                    }
                }
                catch (error) {
                    setLoadPanelVisible(false);
                    notify
                    (
                        {
                            message: "Could not delete Vector Store. An error occurred",
                            width: 100,
                        },
                        'error',
                        3000,
                    );
                }
            }
        })
    }


    const addNewRecordClick = () => {
        setIsFormSubmitted(false);
        skipDataLoading = true;
        setformFields(initialFormFields);
        skipDataLoading = false;
        history.push('/ai/add-vectorstore');
    }

    const GetHeaderInfoById = (id) => {
        try {
            setLoadPanelVisible(true);
            axios.get(`${window._env_.REACT_APP_APIS}/ai/vectorstore/GetVectorStore?Id=${id}`, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            }).then((res) => {
                const responseData = res.data;
                if (responseData.Id) 
                {
                    skipDataLoading = true;
                    setformFields(responseData);
                    skipDataLoading = false;
                }
                else 
                {
                    console.error('Failed to get Vector Store data');
                }
            });


        } catch (error) {
            console.error('Error failed to get Vector Store data:', error);
        } finally {
            setTimeout(hideLoadPanel, 1000);
        }
    };

    useEffect(() => {
        var id = props.id;
        if (id != null && id != undefined && id != '') {
            GetHeaderInfoById(id);
        }
    }, []);

    const goBack = () => {
        history.push("/ai/vectorstore-data-entry");
    };


    const handleFieldChange = useCallback((name, value, e) => {
        
    });
     
    
    const handleSelectionChange = useCallback((name, e) => {
    }, []);

    return (
        <div>
            <div className="row dataEntryMainPage">
                <div className="col-md-12 main-page">
                    <div id="accordion">
                        <LoadPanel
                            shadingColor="rgba(0,0,0,0.4)"
                            position={position}
                            onHiding={hideLoadPanel}
                            visible={loadPanelVisible}
                            showIndicator={true}
                            shading={true}
                            showPane={true}
                            hideOnOutsideClick={false}
                        />
                        <form onSubmit={(e) => handleFormSubmit(e)}>
                            <Toolbar className="header">
                                <Item location="before">
                                    <div className="title">
                                        <h6
                                            style={{
                                                color: window._env_.Color2,
                                                marginLeft: '12px'
                                            }}
                                        >
                                            Vector Store Data Entry
                                        </h6>
                                    </div>
                                </Item>
                                <Item location="after">
                                    <Button
                                        text="Save"
                                        useSubmitBehavior={true}
                                        disabled={isFormSubmitted || formFields.Id == "vs_6823d73320088191bec8ead37a63edd2"}
                                        type="default"
                                        className="accordianButton"
                                    />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={addNewRecordClick} text="New" type="default" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={DeleteClick} text="Delete" disabled={formFields.Id === "" || formFields.Id === null || formFields.Id === undefined || formFields.Id == "vs_6823d73320088191bec8ead37a63edd2"} type="default" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={goBack} text="Back" disabled={props.isOpenAsPopUp} />
                                </Item>
                            </Toolbar>
                            <TabPanel deferRendering={props.id ? true : false} showNavButtons={true} height={"auto"}>
                                <TabItem title="Primary">
                                    <PrimaryTab formFields={formFields} setformFields={setformFields} handleFieldChange={handleFieldChange} handleSelectionChange={handleSelectionChange} primaryFormLookupsLoad={primaryFormLookupsLoad} formRefs={formRefs} />
                                </TabItem>
                                <TabItem title="Files" disabled={!formFields.Id}>
                                    <VectorStoreFilesTab formFields={formFields} />
                                </TabItem>
                            </TabPanel>
                            <div className="row">
                                <ValidationSummary className="pl-3 pt-1" id="summary" />
                            </div>
                        </form>
                    </div>

                </div>
            </div>

        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(Form);
